import { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";

import { Button, Modal, ModalBody, ModalFooter } from "@gpstrackit/react-controls";
import { NotificationManager } from "Components/Notifications";

import {
    resendDealerAlertLogMutation,
    reset
} from './redux/slice';

const ResendDealerAlertLog = (props) => {
    const { messages } = useIntl();
    const dispatch = useDispatch();

    const { openModal, loading, dealerId, log, result, error } = useSelector(
        state => state.resendDealerAlertLogRedux
    );

    const closeModal = () => {
        dispatch(reset());
    };

    const applyChanges = () => {
        if (log?.id && dealerId) {
            dispatch(resendDealerAlertLogMutation({ dealerId, logId: log.id }));
        }
    };

    useEffect(() => {
        if (result) {
            const title = messages['resend_dealer_alert_log_title'];
            const successMessage = messages['resend_dealer_alert_log_success'];
            const errorMessage = messages['resend_dealer_alert_log_error'];

            if (result?.success) {
                NotificationManager.success(successMessage, title, 3000);
                closeModal();
                props?.tableRef && props?.tableRef?.current?.getData();
            } else {
                NotificationManager.error(errorMessage, title, 3000);
                dispatch(reset({ result: null }));
            }
        }
    }, [result]);

    useEffect(() => {
        if (error) {
            const title = messages['resend_dealer_alert_log_title'];
            const errorMessage = messages['resend_dealer_alert_log_error'];
            NotificationManager.error(errorMessage, title, 3000);
            dispatch(reset({ error: false }));
        }
    }, [error]);

    return (
        <Modal
            open={openModal}
            title={messages['resend_dealer_alert_log_title']}
            position="right"
            size="small"
            handleClose={closeModal}
            loading={loading}
        >
            <ModalBody>
                <div style={{ padding: '0 10px', marginBottom: 30 }}>
                    <div style={{ margin: 10 }}>
                        <p>{messages['resend_dealer_alert_log_description']}</p>
                    </div>
                    <div style={{ margin: 10 }}>
                        <p style={{ fontSize: '12px', color: '#666' }}>
                            {messages['resend_dealer_alert_log_log_id']}: {log?.id}
                        </p>
                        <p style={{ fontSize: '12px', color: '#666' }}>
                            {messages['resend_dealer_alert_log_timestamp']}: {log?.timestamp}
                        </p>
                    </div>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn btn-cancel"
                    onClick={() => closeModal()}
                >
                    {messages['common_cancel']}
                </Button>
                <Button
                    className="btn btn-dark-blue"
                    onClick={() => applyChanges()}
                    disabled={loading}
                >
                    {messages['resend_dealer_alert_log_resend']}
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default ResendDealerAlertLog;
